export function numericToNumber(value: string | number | null): number {
  if (typeof value !== "number" && typeof value !== "string") {
    return 0;
  }

  return Number(value);
}
